import { render, staticRenderFns } from "./verificarCodigo.vue?vue&type=template&id=3238ca70&scoped=true&"
import script from "./verificarCodigo.vue?vue&type=script&lang=js&"
export * from "./verificarCodigo.vue?vue&type=script&lang=js&"
import style0 from "./verificarCodigo.vue?vue&type=style&index=0&id=3238ca70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3238ca70",
  null
  
)

export default component.exports